// Components
import SwitchToolbar from "@Layouts/components/Tables/DataSmartTable/toolbar/SwitchToolbar";
import TitleExpandibleToolbar from "@Layouts/components/Tables/DataSmartTable/toolbar/TitleExpandibleToolbar";
import TitleToolbar from "@Layouts/components/Tables/DataSmartTable/toolbar/TitleToolbar";

// MUI
import { Box, Stack, SxProps } from "@mui/material";
import { GridApi } from "@mui/x-data-grid-pro";
import { ChangeEvent, ReactNode, RefObject } from "react";

// Memos
const MemoSwitch = SwitchToolbar;
const MemoTitle = TitleToolbar;
const MemoTitleExpandible = TitleExpandibleToolbar;

interface IRenderContentProps {
	apiRef: RefObject<GridApi>;
	title?: {
		hide?: boolean;
		label?: string;
		classes?: string;
		sx?: SxProps;
	};
	titleExpandible?: {
		title?: string;
		hide?: boolean;
		titleClasses?: string;
		sx?: SxProps;
		sxContainer?: SxProps;
		collapsed?: boolean;
		collapsible?: boolean;
		onClick?: () => void;
	};
	switchProperties?: {
		apiRef?: RefObject<GridApi>;
		hide?: boolean;
		data?: unknown[];
		checked?: boolean;
		searchIn?: string;
		searchValue?: string;
		onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
	};
	customComponent?: ReactNode;
}

function RenderContent(props: Readonly<IRenderContentProps>) {
	const { apiRef, title, titleExpandible, switchProperties, customComponent } = props;

	if (!titleExpandible?.hide) {
		const { title: _title, ...otherProps } = props;
		return (
			<Box sx={{ width: "100%" }}>
				<MemoTitleExpandible {...otherProps} {...titleExpandible} />
			</Box>
		);
	}

	return (
		<Box ml={0}>
			{!title?.hide && <MemoTitle {...title} />}
			{!switchProperties?.hide && <MemoSwitch {...switchProperties} apiRef={apiRef} />}
			{customComponent}
		</Box>
	);
}

interface IHeaderToolbarProps extends IRenderContentProps {}
function HeaderToolbar(props: Readonly<IHeaderToolbarProps>) {
	const {
		apiRef,
		title = {
			hide: true,
			disabled: false,
			label: "",
		},
		titleExpandible = {
			hide: true,
			disabled: false,
			collapsible: false,
			collapsed: false,
			title: "",
			titleClasses: "",
			sx: null,
			sxContainer: null,
			onClick: () => {},
		},
		switchProperties = {
			onChange: () => {},
			disabled: false,
			hide: true,
			data: [],
			searchValue: "",
			searchIn: "",
			textRight: true,
			textChecked: "Active",
			textUnChecked: "Inactive",
		},
		customComponent,
	} = props;

	return (
		<Stack className="!w-full">
			<RenderContent
				apiRef={apiRef}
				title={title}
				titleExpandible={titleExpandible}
				switchProperties={switchProperties}
				customComponent={customComponent}
			/>
		</Stack>
	);
}

export default HeaderToolbar;
